export enum NotificationType {
  SHOW_LESS = 'BROWSE_SHOW_LESS',
}

export enum ModalType {
  GROUP_CLOSED_WATCH = 'GROUP_CLOSED_WATCH',
  GROUP_JOIN_PENDING = 'GROUP_JOIN_PENDING',
}
